import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CondicoesContratacaoService {

  constructor( private readonly http: HttpClient ) { }

  public getCondicoes(idEmpresa) {
    return this.http.get(`/apiconnect/importation/hire/condition/${idEmpresa}/companies`);  
  }

  public getUrlContrato() {
    return this.http.get(`/apiconnect/importation/contract-products-address`);
  }

  public dowloadArquivoPdf(s3Url: string) {
    return this.http.get('/s3bucket/' + s3Url,  {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }
}
